import React from 'react'
import PropTypes from 'prop-types'
import { ChannelTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const ConfigurationCanal = ({
  fetchData,
  success,
  isLoadingChannelList,
  pageLimitChanged,
  pageChanged,
  searchData,
  onCloseReset,
  salesChannel,
  salesChannelCount,
  errorMessage,
  removeError,
  isErrorFetch,
  isSuccessRefresh,
  resetSuccessAction,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={ChannelTableHead}
      //Commonfields
      globalID={'salesChannel'}
      searchPlaceholder={'Rechercher par canal de vente'}
      title={'Association Clés-Canal'}
      fetchData={fetchData}
      loadingData={isLoadingChannelList}
      dataList={salesChannel}
      countData={salesChannelCount}
      errorMessage={errorMessage}
      removeError={removeError}
      removeErrorConfig={() => {}}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isChannel={true}
    />
  )
}
ConfigurationCanal.propTypes = {
  fetchData: PropTypes.func,
  isLoadingChannelList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchData: PropTypes.func,
  onCloseReset: PropTypes.func,
  success: PropTypes.bool,
  salesChannel: PropTypes.array,
  salesChannelCount: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
}
export default ConfigurationCanal
